import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Justification } from '../models/justification';
import { deleteJustificationEndpoint } from './const';

export const deleteJustification = (justification: Justification) => {
    justification.isDeleted = true;
    return getHttpClient().post({ url: deleteJustificationEndpoint, data: JSON.stringify(justification) });
};
